// import React, { useState, useEffect } from 'react';
// import { Outlet } from 'react-router-dom'
// import Navbar from '../layouts/navbarBK'
// import Loader from '../layouts/loader';
// import { LanguageProvider } from './languageContext';

// const DashboardLayout = ({ children }) => {
//   const [authToken, setAuthToken] = useState(null);
//   const [loader, setLoader] = useState(true);

//   useEffect(() => {
//     const urlParams = new URLSearchParams(window.location.search);
//     const token = urlParams.get('ref');
//     let decodedRef
//     if (token) {
//       decodedRef = decodeURIComponent(token);
//       decodedRef = JSON.parse(decodedRef);
//       setAuthToken(decodedRef.token);
//       localStorage.setItem('authToken', decodedRef.token);
//       sessionStorage.setItem("userDetail", JSON.stringify(decodedRef));
//       // Optionally redirect to the initial route after saving data
//       window.history.replaceState({}, document.title, window.location.pathname);
//       setLoader(false);
//     } else {
//       setLoader(false);
//     }
//   }, []);

//   return (
//     <>
//     {loader ? <Loader/> :
//     <Navbar children={children} showFooter={false}>
//             <Outlet/>
//         </Navbar>
//    }
//     </>
//   );
// };

// export default DashboardLayout;


import React, { useState, useEffect } from 'react';
import { Outlet } from 'react-router-dom'
import Navbar from '../layouts/navbar'
import Loader from '../layouts/loader';
import { LanguageProvider } from './languageContext';
import apiService from '../../services/apiService';

const DashboardLayout = ({ children }) => {
  const [authToken, setAuthToken] = useState(null);
  const [loader, setLoader] = useState(true);

  // Improved token parsing function
  const parseTokenFromUrl = () => {
    try {
      const urlParams = new URLSearchParams(window.location.search);
      const token = urlParams.get('ref');
      
      if (!token) {
        console.log("No token found in URL parameters");
        return null;
      }

      console.log("Raw token from URL:", token);

      // First decode URI component (handles URL encoding like %22, %3A, etc.)
      const decodedToken = decodeURIComponent(token);
      console.log("Decoded token:", decodedToken);
      
      // Try to parse as JSON
      try {
        const parsedToken = JSON.parse(decodedToken);
        console.log("Successfully parsed JSON token:", parsedToken);
        return parsedToken;
      } catch (jsonError) {
        console.error("JSON parsing failed:", jsonError);
        return null;
      }
    } catch (error) {
      console.error("Error parsing token from URL:", error);
      return null;
    }
  };

  useEffect(() => {
    let userTokenDetails = sessionStorage.getItem('tokenDetails');
    console.log("userTokenDetails", userTokenDetails);

    // Use the improved token parsing
    const decodedRef = parseTokenFromUrl();
    
    if (decodedRef && decodedRef.token) {
      try {
        console.log("Setting auth token:", decodedRef.token);
        setAuthToken(decodedRef.token);
        localStorage.setItem('authToken', decodedRef.token);
        sessionStorage.setItem("userDetail", JSON.stringify(decodedRef));
        
        // Store org_id if available
        if (decodedRef.org_id) {
          localStorage.setItem("ORGID", decodedRef.org_id);
        }

        // Clean up URL by removing query parameters
        window.history.replaceState({}, document.title, window.location.pathname);
        console.log("Token successfully processed and stored");
      } catch (error) {
        console.error("Failed to process decoded token:", error);
      }
    } else {
      console.log("No valid token found or token structure is invalid");
    }


     //  try {
  //       // Retrieve the token from the URL parameters
  //       const urlParams = new URLSearchParams(window.location.search);
  //       const token = urlParams.get('ref');
  
  //       if (token) {
  //         // Decode and parse the token
  //         let decodedRef = decodeURIComponent(token);
  //         decodedRef = JSON.parse(decodedRef);
  
  //         // Update state with the token
  //         setAuthToken(decodedRef.token);
  
  //         // Save the token to local storage
  //         localStorage.setItem('authToken', decodedRef.token);
  //         sessionStorage.setItem("userDetail", JSON.stringify(decodedRef));
  //         localStorage.setItem("ORGID", decodedRef.org_id);
  
  //         // Fetch additional data using the token
  //         const response = apiService.getv1(`get-org-details/${decodedRef?.org_id}`, decodedRef?.token);

  //         if (response?.status === 'success') {
  //           localStorage.setItem('orgInfo', JSON.stringify(response?.data));
  
  //           if (response?.data && response?.data?.org_image && response?.data?.org_image != null && response?.data?.org_image !="null") {
  //             localStorage.setItem('image', response?.data?.org_image);
  //           }
  //         }
  
  //         // Clear the URL parameters
  //         window.history.replaceState({}, document.title, window.location.pathname);
  
  //         // Set loader to false
  //         setLoader(false);
  //       } else {
  //         // No token found in URL parameters
  //         setLoader(false);
  //       }
  //     } catch (error) {
  //       // Handle errors, e.g., display an error message
  //       console.error('Error fetching token and data:', error);
  //       setLoader(false);
  //     }
  
    
    setLoader(false);
  }, []);
  
  return (
    <>
    {loader ? <Loader/> :
        <Navbar children={children} showFooter={false}>
          <Outlet />
        </Navbar>
   }
    </>
  );
};

export default DashboardLayout;